import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73004e24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 pb-2" }
const _hoisted_2 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_3 = {
  key: 0,
  class: "col-lg-6 mb-2"
}
const _hoisted_4 = {
  key: 1,
  class: "col-md-12 col-lg-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServiceOverviewItemCard = _resolveComponent("ServiceOverviewItemCard")!
  const _component_ServiceOverviewItemCardSkeleton = _resolveComponent("ServiceOverviewItemCardSkeleton")!
  const _component_ProductOverviewLayout = _resolveComponent("ProductOverviewLayout")!

  return (_openBlock(), _createBlock(_component_ProductOverviewLayout, {
    vm: _ctx.overviewVm,
    onOnFilterChange: _ctx.onFilterChange,
    onOnSearch: _ctx.onSearch,
    onOnSortChange: _ctx.onSortChange
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "breadcrumbs", {}, undefined, true),
        (_ctx.vm.pageTitle)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.vm.pageTitle), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    "grid-item": _withCtx(({ data }) => [
      (!_ctx.isSpinnerVisible('product-overview'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_ServiceOverviewItemCard, {
              compact: _ctx.isSmallScreen,
              item: data,
              layout: "grid"
            }, null, 8, ["compact", "item"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ServiceOverviewItemCardSkeleton, { type: "list" })
          ]))
    ]),
    "list-item": _withCtx(({ data }) => [
      (!_ctx.isSpinnerVisible('product-overview'))
        ? (_openBlock(), _createBlock(_component_ServiceOverviewItemCard, {
            key: 0,
            item: data,
            layout: "list"
          }, null, 8, ["item"]))
        : (_openBlock(), _createBlock(_component_ServiceOverviewItemCardSkeleton, {
            key: 1,
            type: "list"
          }))
    ]),
    _: 3
  }, 8, ["vm", "onOnFilterChange", "onOnSearch", "onOnSortChange"]))
}